import barGraph from './barGraph';
import cameras from './cameras';
import equipmentMap from './equipmentMap';
import events from './events';
import gasMeter from './gasMeter';
import gates from './gates';
import generic from './generic';
import graphs from './graphs';
import monitoringActions from './monitoringActions';
import padlocks from './padlocks';
import portal from './portal';
import pumps from './pumps';
import shutoffThreshold from './shutoffThreshold';
import site from './site';
import status from './status';
import tanks from './tanks';
import totalFlowMeters from './totalFlowMeters';
import tripwires from './tripwires';
import voiceDown from './voiceDown';
import weather from './weather';
export default {
    barGraph,
    cameras,
    equipmentMap,
    tanks,
    totalFlowMeters,
    tripwires,
    events,
    gasMeter,
    gates,
    generic,
    graphs,
    monitoringActions,
    padlocks,
    portal,
    pumps,
    shutoffThreshold,
    site,
    status,
    voiceDown,
    weather,
};
